export class ArcgisItemsRoutingConstants {
    static ARCGIS_ITEMS_ROUTE = "arcgisitems";
}
